import { createContext, PropsWithChildren } from 'react';
import {
  WebSdkEventHandlers,
  WebSdkInitOptions,
} from 'src/webSdk/models/webSdk';

interface WebSdkProviderProps {
  initOptions?: WebSdkInitOptions;
  eventHandlers?: WebSdkEventHandlers;
}

export const WebSdkContext = createContext<WebSdkProviderProps | undefined>(
  undefined
);

export const WebSdkProvider = ({
  initOptions,
  eventHandlers,
  children,
}: PropsWithChildren<WebSdkProviderProps>) => (
  <WebSdkContext.Provider value={{ initOptions, eventHandlers }}>
    <div>{children}</div>
  </WebSdkContext.Provider>
);
